import dynamic from "next/dynamic";
import React from "react";
const Timeline = dynamic(() => import("./Timeline"),{ssr: true});
//import Image from "next/image";

interface AccordionProps {
  data?: any;
}

const Process: React.FC<AccordionProps> = ({ data }) => {
  //const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  return (
    <div className="bg-background-dark text-white relative overflow-hidden">
      <section className="bg-background-white xl:py-25 md:py-[80px] py-[56px] relative">
        <div className="container mx-auto px-4 relative z-10">
          {/* Heading */}
          <h2 className="text-heading-1 font-bold text-center capitalize max-w-[1230px] mx-auto">
            {data?.title ?? ""}
          </h2>
          {data?.short_title && (
            <p className="text-heading-6 font-normal text-center max-w-[914px] mx-auto mt-3">
              {data?.short_title ?? ""}
            </p>
          )}

          <Timeline steps={data?.steps ?? []} />
        </div>

        {/* Background Images */}
        <div
          className="absolute top-0 left-0 right-0 z-0 w-full bg-no-repeat hidden md:block h-full"
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/images/consulting/bg-approch.png')",
          }}
        />
      </section>
    </div>
  );
};

export default Process;
